export const gameEvents: TableModule = {
    name: "gameEvents",
    route: "spa.sportsManagement.gameDays.games.gameEvents",
    defaultOrder: {
        column: "CAST(time AS INT)",
        direction: "asc"
    },
    routeParams: [{
        param: "gameDay",
        prop: "game_day_id"
    }, {
        param: "game",
        prop: "game_id"
    }],
    columns: [
        {
            name: "type",
            pageLink: true,
            mobile: true,
            sortable: true,
        }, {
            name: "team",
        }, {
            name: "person",
            breakpoint: "md"
        }, {
            name: "time",
            sortable: true,
            sortBy: "CAST(time AS INT)",
            mobile: true,
            width: "w-[125px]"
        }, {
            name: "createdByUser",
        }
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "gameEvents"]
        }
    ]
}